import { Component, HostBinding, HostListener } from '@angular/core'
import { WindowRef } from '@spartacus/core'

@Component({
    selector: 'eb-back-to-top-button',
    templateUrl: './eb-back-to-top-button.component.html',
    styleUrls: ['./eb-back-to-top-button.component.scss'],
    standalone: false
})
export class EbBackToTopButtonComponent {
  @HostBinding('style.visibility') buttonVisibility = 'hidden'

  constructor(protected winRef: WindowRef) {}

  @HostListener('window:scroll')
  onScrollEvent() {
    if (this.winRef.nativeWindow.scrollY >= 100) {
      this.buttonVisibility = 'visible'
    } else {
      this.buttonVisibility = 'hidden'
    }
  }

  handleBackToTopClick() {
    this.winRef.nativeWindow.scrollTo(0, 0)
  }
}
